import { render, screen } from '@testing-library/react'
import MenstrualCultureDefinition from './MenstrualCultureDefinition'

test('shows the definition content directly without a collapsible toggle', () => {
  render(<MenstrualCultureDefinition />)

  expect(screen.getByRole('heading', { name: /¿Qué entendemos por cultura menstrual\?/i })).toBeTruthy()
  expect(screen.queryByRole('button')).toBeNull()
  expect(screen.getByText(/La cultura, según la UNESCO/i)).toBeTruthy()
})

